import api from "./api";

export interface LoginLocalParams {
  email: string;
  senha: string;
}

export interface LoginSsoParams {
  email: string;
  tokenSso: string;
}

// Inicia o fluxo de autenticação com base no e-mail informado
// Endpoint: POST /api/auth/loginInit
export const loginInit = async (email: string) => {
  const payload = { email };
  return api.post("/api/auth/loginInit", payload);
};

// Realiza login local com e-mail e senha
// Endpoint: POST /api/auth/login
export const loginLocal = async ({ email, senha }: LoginLocalParams) => {
  const payload = { email, senha };
  return api.post("/api/auth/login", payload);
};

// Realiza login via SSO com e-mail e token de autenticação
// Endpoint: POST /api/auth/login
export const loginSso = async ({ email, tokenSso }: LoginSsoParams) => {
  const payload = { email, tokenSso };
  return api.post("/api/auth/login", payload);
};

// Renova o token de acesso utilizando o refresh token
// Endpoint: POST /api/auth/refresh
export const refreshToken = async (refreshTokenValue: string) => {
  const payload = { refreshToken: refreshTokenValue };
  return api.post("/api/auth/refresh", payload);
};

// Busca os dados do perfil do usuário autenticado
// Endpoint: GET /api/usuario/getPerfil
export const getPerfil = () => {
  return api.get("/api/usuario/getPerfil");
};
